
import Vue from "vue";
import {
  getConferenceList,
  deleteConference,
  getConferenceDetail,
  createConference,
  updateConference,
  importOrder,
  getAllLetters,
  getBaseUrl
} from "@/utils/api";
import fileBaseUrl from "@/plugins/urlBase";
import JSZip from "jszip";
import FileSaver from "file-saver";
import md5 from 'md5';
export default Vue.extend({
  name: "message-management",
  data() {
    return {
      uploadSecret: 'b7f3c1a4e06d9b8c5f2a1e7c0f4d8a29', // 与后端一致
      uploadData: {
        bucket: 'cic',
        fileName: '',
        signature: ''
      },
      tableData: [],
      searchGroup: {
        code: "",
        name: '',
        abbreviation: "",
        date: ""
      } as any,
      total: 0,
      page: 1,
      limit: 20,
      timer: null,
      loading: false,
      defaultTime: ["00:00:00", "23:59:59"],
      otherRemind: 0,
      approveNumSum: 0,
      dialogVisible: false,
      dialogMode: '' as 'view' | 'edit' | 'new' | '',
      form: {
        name: '',
        venue: '',
        date: '',
        abbreviation: '',
        overview: '',
        publication: '',
        indexation: '',
        stamp: '',
        logo: []
      } as any,
      rules: {
        name: [{ required: true, message: '请输入会议名称', trigger: 'blur' }],
        venue: [{ required: true, message: '请输入地点', trigger: 'blur' }],
        date: [{ required: true, message: '请输入日期', trigger: 'blur' }],
        abbreviation: [{ required: true, message: '请输入简称', trigger: 'blur' }],
        overview: [{ required: true, message: '请输入会议简介', trigger: 'blur' }],
        publication: [{ required: true, message: '请输入出版信息', trigger: 'blur' }],
        indexation: [{ required: true, message: '请输入检索信息', trigger: 'blur' }],
        stamp: [{ validator: (rule: any, value: any, cb: any) => { !value ? cb(new Error('请上传 Stamp')) : cb(); }, trigger: 'change' }],
        logo: [{
          validator: (rule: any, value: any, cb: any) => {
            if (Array.isArray(value)) {
              return value.length > 0 ? cb() : cb(new Error('请上传 Indexation logo'))
            }
            return value ? cb() : cb(new Error('请上传 Indexation logo'))
          }, trigger: 'change'
        }]
      },
      currentId: null as any,
      fileBaseUrl: fileBaseUrl as any,
      stampFileList: [] as any[],
      indexationFileList: [] as any[]
    };
  },
  computed: {
    isEdit(): boolean {
      return this.dialogMode === 'edit' || this.dialogMode === 'new';
    },
    dialogTitle(): string {
      if (this.dialogMode === 'view') return 'View Conference';
      if (this.dialogMode === 'edit') return 'Edit Conference';
      if (this.dialogMode === 'new') return 'Create Conference';
      return 'Conference';
    }
  },
  created() {
    this.getTableData()
  },
  methods: {
    // 上传前的处理函数
    beforeStampUpload(file: any) {
      // 1. 生成签名
      const bucket = 'cic';
      const fileName = file.name;
      const signature = this.makeUploadSignature(bucket, fileName);

      // 2. 更新 uploadData
      this.uploadData.fileName = fileName;
      this.uploadData.signature = signature;

      return true;
    },
    // 生成签名的辅助函数
    makeUploadSignature(bucket: any, fileName: any) {
      const canonical = [bucket, fileName].join('\n');
      const firstDigest = md5(canonical);
      return md5(firstDigest + this.uploadSecret);
    },
    // 顶部按钮
    /*
    * 下载学生名单模板*/
    downloadTemplate() {
      // this.$message.info('暂未集成导入模板下载');
      const href = './投递老师批量投稿 - 表头.xlsx'
      const a = document.createElement("a");
      a.href = href;
      a.download = `导入模板.xlsx`;
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
    createConferenceClick() {
      this.openConferenceDialog('', 'new');
    },
    // 打开会议信息弹框
    async openConferenceDialog(id: any, mode: 'view' | 'edit' | 'new') {
      this.dialogMode = mode;
      this.currentId = id || null;
      if (mode === 'new') {
        this.form = { name: '', venue: '', date: '', abbreviation: '', overview: '', publication: '', indexation: '', stamp: '', logo: [] } as any;
        this.stampFileList = [];
        this.indexationFileList = [];
        this.dialogVisible = true;
        return;
      }
      this.loading = true;
      try {
        const res: any = await getConferenceDetail(id);
        this.form = {
          name: res.name || '',
          venue: res.venue || '',
          date: res.date || res.date || '',
          abbreviation: res.abbreviation || '',
          overview: res.overview || '',
          publication: res.publication || '',
          indexation: res.indexation || '',
          stamp: res.stamp || '',
          logo: Array.isArray(res.logo) ? res.logo : (res.logo ? [res.logo] : [])
        } as any;
        this.stampFileList = this.form.stamp ? [{ name: 'stamp', url: this.form.stamp }] : [];
        this.indexationFileList = (this.form.logo || []).map((u: string, idx: number) => ({ name: `logo_${idx + 1}`, url: u }));
        this.dialogVisible = true;
      } catch (e) {
        this.$message.error('获取会议信息失败');
      } finally {
        this.loading = false;
      }
    },
    // 上传处理
    handleStampSuccess(res: any) {
      if (res.error && res.error.returnMessage === 'success') {
        this.form.stamp = res.data.ossUrl;
        this.stampFileList = [{ name: res.data.name, url: res.data.ossUrl }];
        (this.$refs.confForm as any).validateField('stamp');
      } else {
        this.$message.error('上传失败');
        this.stampFileList = [];
      }
    },
    handleStampRemove() {
      this.form.stamp = '';
      this.stampFileList = [];
      (this.$refs.confForm as any).validateField('stamp');
    },
    handleIndexationSuccess(res: any, file: any, fileList: any[]) {
      if (res.error && res.error.returnMessage === 'success') {
        const url = res.data.ossUrl
        if (!Array.isArray(this.form.logo)) this.form.logo = []
        this.form.logo.push(url)
        this.indexationFileList = fileList.map((f: any, idx: number) => ({ name: f.name || `logo_${idx + 1}`, url: (f.response ? f.response.data.ossUrl : f.url) }))
          ; (this.$refs.confForm as any).validateField('logo')
      } else {
        this.$message.error('上传失败');
        this.indexationFileList = fileList || []
      }
    },
    handleIndexationRemove(file: any, fileList: any[]) {
      const url = file && (file.url || (file.response && file.response.data && file.response.data.ossUrl))
      if (url && Array.isArray(this.form.logo)) {
        this.form.logo = this.form.logo.filter((u: string) => u !== url)
      }
      this.indexationFileList = (fileList || []).map((f: any, idx: number) => ({ name: f.name || `logo_${idx + 1}`, url: (f.response ? f.response.data.ossUrl : f.url) }))
        ; (this.$refs.confForm as any).validateField('logo')
    },
    handleExceed() {
      this.$message({ message: '只能上传一个文件，请先删除已上传的文件', type: 'warning' });
    },
    async submitConference() {
      (this.$refs.confForm as any).validate(async (valid: boolean) => {
        if (!valid) return;
        this.loading = true;
        try {
          if (this.dialogMode === 'new') {
            await createConference(this.form);
          } else if (this.dialogMode === 'edit') {
            await updateConference(this.currentId, this.form);
          }
          this.$message.success('保存成功');
          this.dialogVisible = false;
          this.getTableData();
        } catch (e) {
          this.$message.error('保存失败');
        } finally {
          this.loading = false;
        }
      });
    },
    copyLink(row: any) {
      const conferenceId = row?.id;
      // 判断当前环境（正式环境使用固定域名，其他环境使用当前域名）
      const baseUrl = getBaseUrl();
      const url = `${baseUrl}/submission?conferenceId=${encodeURIComponent(conferenceId)}&from=conference`;
      this.copyText(url).then(() => {
        this.$message.success('链接已复制');
      }).catch(() => {
        this.$message.error('复制失败，请手动复制');
      });
    },
    async copyText(text: string) {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return;
      }
      return new Promise<void>((resolve, reject) => {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        try {
          const successful = document.execCommand('copy');
          successful ? resolve() : reject();
        } catch (e) {
          reject(e as any);
        } finally {
          document.body.removeChild(textarea);
        }
      });
    },
    // 直接点击按钮选择Excel文件并导入
    importManuscript(row: any) {
      const conferenceId = row.id;

      // 创建隐藏的文件输入元素
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = '.xlsx,.xls';
      input.style.display = 'none';

      input.onchange = async (event: any) => {
        const file = event.target.files[0];
        if (!file) return;

        // 验证文件类型
        const isExcel = /\.(xlsx|xls)$/i.test(file.name);
        if (!isExcel) {
          this.$message.error('仅支持 .xlsx/.xls 文件');
          return;
        }

        try {
          // 显示加载状态
          this.loading = true;

          // 构建FormData
          const formData = new FormData();
          formData.append('1', file);
          formData.append('cid', conferenceId);

          // 调用API
          await importOrder(formData);

          this.$message.success('导入成功');

          // 跳转到OrderImport Management页面
          this.$router.push('/order-management');
        } catch (e) {
          this.$message.error('导入失败');
        } finally {
          this.loading = false;
        }
      };

      // 触发文件选择
      document.body.appendChild(input);
      input.click();
      document.body.removeChild(input);
    },
    async deleteConference(id: any) {
      deleteConference(id).then((res: any) => {
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
        this.getTableData()
      }).catch((err: any) => {
        // console.log(err)
      })
    },
    async downloadAllLetters(row: any) {
      // 获取对应的所有链接

      const urlList: any = await getAllLetters(row.id)
      console.log(urlList);

      if (urlList.length > 0) {
        this.loading = true
        const zip = new JSZip();
        // 使用Promise.all并发下载PDF文件并添加到压缩文件
        await Promise.all(
          urlList.map(async (item: any, index: any) => {
            const response = await fetch((item as any).acceptanceLetterUrl);
            const pdfData = await response.blob();
            // 从URL中提取文件名，而不是使用完整路径
            const fileName = this.extractFileNameFromUrl((item as any).acceptanceLetterUrl);

            // 使用简洁的文件名，避免路径嵌套
            zip.file(fileName, pdfData);
          })
        );
        // 生成压缩文件
        const zipBlob = await zip.generateAsync({ type: 'blob' });
        FileSaver.saveAs(zipBlob, '投递函.zip'); // 利用file-saver保存文件  自定义文件名
        this.loading = false
      } else {
        this.$message.warning('暂无投递函');
      }

    },
    // 新增方法：从URL中提取文件名
    extractFileNameFromUrl(url: string): string {
      if (!url) return 'unknown.pdf';

      try {
        // 方法1：使用URL对象解析
        const urlObj = new URL(url);
        const pathname = urlObj.pathname;
        const fileName = pathname.split('/').pop() || 'unknown.pdf';
        return decodeURIComponent(fileName);
      } catch (error) {
        // 方法2：如果URL解析失败，使用字符串分割
        const parts = url.split('/');
        const fileName = parts.pop() || 'unknown.pdf';
        return decodeURIComponent(fileName);
      }
    },
    getTableData() {
      const searchParams: any = JSON.parse(JSON.stringify(this.searchGroup))
      if (searchParams.createdAt && searchParams.createdAt.length) {
        searchParams.createdAt[0] = searchParams.createdAt[0] + ' 00:00:00'
        searchParams.createdAt[1] = searchParams.createdAt[1] + ' 23:59:59'
      }

      const obj: any = {
        page: this.page,
        limit: this.limit,
        ...searchParams,
      };
      // 去掉空值
      for (const key in obj) {
        if (
          obj[key] === "" ||
          obj[key] === null ||
          (Array.isArray(obj[key]) && obj[key].every((v: any) => v === null || v === undefined)) ||
          obj[key].length === 0
        ) {
          delete obj[key];
        }
      }
      getConferenceList(obj)
        .then((res: any) => {
          this.tableData = res.rows;
          this.total = res.count;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    formatDate(date: any, formatStr = "yyyy-MM-dd HH:mm:ss") {
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      return formatStr
        .replace("yyyy", year)
        .replace("MM", String(month).padStart(2, "0"))
        .replace("dd", String(day).padStart(2, "0"))
        .replace("HH", hours)
        .replace("mm", minutes)
        .replace("ss", seconds);
    },
    // 兼容旧逻辑：保留以免其他地方调用
    handleView(id: any) {
      this.openConferenceDialog(id, 'view')
    },
    onPageChange(page: number) {
      this.page = page;
      this.getTableData();
    },
    handleSizeChange(limit: number) {
      this.limit = limit;
      this.getTableData();
    },
    pageChange(page: number) {
      if (this.timer !== null) clearTimeout(this.timer as any);
      (this.timer as any) = setTimeout(() => {
        this.page = page;
        this.getTableData();
      }, 1000);
    },
  },
});
